import styled from 'styled-components';
import { getActiveElementBackground, getHoveredElementBackground } from '@styles/globalsStyles';
const boxStyle = 'rounded-lg border border-solid border-my-gray-70';
export const FileListWrapper = styled.div.withConfig({
  componentId: "sc-1d3a7z-0"
})(["&{", " ", " input#add-file{", "}label.add-file-box{", " ", " ", " &:hover{background:", ";}&:active{background:", ";}> div{", "}}.file-wrapper{", " ", " > img{", "}> button.delete-button{", " top:-0.3rem;right:-0.3rem;z-index:5;}}}"], {
  "height": "100%",
  "width": "100%",
  "gap": "0.5rem"
}, props => props.wrapperStyles, {
  "display": "none"
}, {
  "position": "relative",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))"
}, {
  "cursor": "pointer",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
}, props => props.buttonStyles, getHoveredElementBackground('white'), getActiveElementBackground('white'), {
  "top": "0px",
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem"
}, {
  "position": "relative",
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))"
}, props => props.boxStyles, {
  "borderRadius": "0.5rem"
}, {
  "position": "absolute"
});